<template>
  <div id="app">
    <div class="index-page sidebar-collapse">
      <!-- <Navbar /> -->
      <router-view />
      <!-- <audio id="musica" loop>
        <source src="music/sofu-game-background-music.mp3" type="audio/mp3" />
        Tu navegador no soporta la reproducción de audio mp3.
      </audio> -->
      <Fondo></Fondo>
    </div>
  </div>
</template>

<script>
import Fondo from "@/components/Fondo.vue";
import Vue from "vue";
import loading from "vuejs-loading-screen";
Vue.use(loading, {
  bg: "rgba(0,0,0,0.5);",
  slot: `
    <div class="px-5 py-3 bg-gray-800 rounded">
      <h3 class="text-4xl text-primary"><i class="fas fa-circle-notch fa-spin" style="font-size: 50pt"></i></h3>
    </div>
  `,
});

export default {
  components: {
    Fondo,
    //   Navbar,
  },
};
</script>

<style>
@font-face {
  font-family: "FolksShades";
  src: url(assets/FolksShades.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
div {
  animation: zoomIn;
  animation-duration: 0.5s;
}
body {
  background-color: #222;
}
</style>
